// Datos de la empresa que usan el pie, los botones de contacto y las páginas legales.
// Un valor vacío no se muestra.
export const SITE = {
  url: 'https://www.variant.com.co',
  brand: 'Variant',
  legalName: 'Aplicaciones y Desarrollos Inteligentes S.A.S.',
  nit: '901993716-3',
  city: 'Bogotá, Colombia',
  email: 'service@variant.com.co',
  whatsapp: '573209683760',
  whatsappDisplay: '+57 320 968 3760',
  socials: [
    { name: 'Instagram', url: 'https://www.instagram.com/variant.com.co/' },
  ],
}

export const POLICY_DATE = '28 de octubre de 2026'

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`

export const WA_SECRETARIO = waLink(
  'Hola, quiero solicitar acceso a Secretario.'
)
export const WA_PROYECTO = waLink(
  'Hola, quiero hablar con Variant sobre un proyecto.'
)
